import { render, staticRenderFns } from "./LoadingPoint.vue?vue&type=template&id=53e01c06"
import script from "./loadingPoint.ts?vue&type=script&lang=js&external"
export * from "./loadingPoint.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports